<ces-asset-breadcrumb [trail]="breadcrumbTrail()" />

<div class="px-(--space-4)">
  <ces-route-title [count]="totalRecords()">
    @if (currentAssetId(); as assetId) {
      <ces-button
        [hasPermission]="{ method: 'postTableListResource', assetId }"
        [label]="'tables.createTable' | transloco"
        icon="add"
        (onClick)="onCreateTable()" />
    }
  </ces-route-title>

  <div class="mt-(--space-4)">
    <ces-generic-parent-grid
      [entityDefinition]="entityDefinition()"
      [entities]="tables()"
      [dataLoadingCompleted]="true"
      [selectionMode]="false"
      [paginator]="true"
      [totalRecords]="totalRecords()"
      [first]="first()"
      [rows]="rows()"
      [initialFilters]="urlFilters()"
      (lazyLoad)="onLazyLoad($event)"
      (customAction)="onRowAction($event.action, $event.entity, $event.event)" />
  </div>
</div>

<ces-popup-menu #actionMenu [items]="menuItems()" />
